import { QueryClient, type DefaultOptions, type UseMutationOptions, type UseQueryOptions } from '@tanstack/react-query';
import type { ApiErrorResponse } from './apiClient';

// Sets global error type for React Query
declare module '@tanstack/react-query' {
  interface Register {
    defaultError: ApiErrorResponse;
  }
}

const queryConfig: DefaultOptions = {
  queries: {
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});

export type QueryOptions<T> = Omit<UseQueryOptions<T>, 'queryKey' | 'queryFn'>;

export type MutationOptions<TData, TVariables = void> = Omit<UseMutationOptions<TData, ApiErrorResponse, TVariables>, 'mutationKey' | 'mutationFn'>;
